// CodeImpactCard.jsx — أثر أكواد الحملات: استخدامات كل كود من بيانات RETM
// (تقارير الكوبونات المرفوعة) → إيراد حقيقي + نسبة تحويل لكل حملة.
import React, { useEffect, useState } from "react";
import { api } from "./lib/api";

const fm = (n) => (Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

export default function CodeImpactCard() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/discount-codes/roi").then((r) => setItems(r.data?.items || [])).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  const totalRev = items.reduce((s, x) => s + (x.revenue || 0), 0);
  const totalUses = items.reduce((s, x) => s + (x.uses || 0), 0);

  return (
    <div className="card" data-testid="code-impact-card" style={{ marginBottom: 14, padding: 0, overflow: "hidden" }}>
      <div style={{
        padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8,
        background: "linear-gradient(135deg, rgba(124,58,237,0.07) 0%, rgba(194,169,127,0.05) 100%)",
        borderBottom: "1px solid var(--border)",
      }}>
        <div>
          <div style={{ fontSize: 14.5, fontWeight: 800, color: "var(--brown-deep)" }}>🎟 أثر أكواد الحملات (ROI حقيقي)</div>
          <div style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 2 }}>
            يُقاس من تقارير كوبونات RETM المرفوعة — حملات واستبيانات، كلٌّ بكوده الموحّد.
          </div>
        </div>
        <div style={{ fontSize: 12, fontWeight: 800, color: "#7C3AED" }} data-testid="code-impact-totals">
          {fm(totalUses)} استخدام · {fm(totalRev)} ر.س إيراد
        </div>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
          <thead>
            <tr style={{ background: "var(--beige)", color: "var(--brown-deep)" }}>
              <th style={th}>المصدر</th>
              <th style={th}>الحملة / الاستبيان</th>
              <th style={th}>الكود</th>
              <th style={th}>أُرسلت لـ</th>
              <th style={th}>استخدامات</th>
              <th style={th}>نسبة استخدام الكود</th>
              <th style={th}>إيراد</th>
              <th style={th}>خصم مصروف</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={`${it.source || "campaign"}-${it.campaign_id}`} data-testid={`code-impact-row-${it.campaign_id}`} style={{ borderTop: "1px solid var(--border)" }}>
                <td style={td}>
                  <span data-testid="code-impact-source" style={{
                    fontSize: 10.5, fontWeight: 800, padding: "2px 8px", borderRadius: 999,
                    background: it.source === "survey" ? "rgba(37,211,102,0.12)" : "rgba(124,58,237,0.10)",
                    color: it.source === "survey" ? "#128C4B" : "#7C3AED",
                  }}>{it.source === "survey" ? "استبيان" : "حملة"}</span>
                </td>
                <td style={{ ...td, fontWeight: 700, color: "var(--brown-deep)" }}>{it.campaign_name}</td>
                <td style={{ ...td, fontFamily: "monospace", color: "#7C3AED", fontWeight: 700 }} dir="ltr">{it.code}</td>
                <td style={td}>{fm(it.sent)} / {fm(it.recipients)}</td>
                <td style={{ ...td, fontWeight: 800 }}>{fm(it.uses)}</td>
                <td style={{ ...td, fontWeight: 700, color: (it.conversion_pct || 0) >= 10 ? "#16A34A" : "var(--brown-deep)" }}>
                  {it.conversion_pct != null ? `${it.conversion_pct}%` : "—"}
                </td>
                <td style={{ ...td, fontWeight: 800, color: "#16A34A" }}>{fm(it.revenue)} ر</td>
                <td style={{ ...td, color: "#D97706" }}>{fm(it.discount_given)} ر</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ padding: "8px 18px", fontSize: 10.5, color: "var(--muted)" }}>
        💡 تتحدّث الأرقام تلقائياً كلما رفع مدير التشغيل تقرير كوبونات جديد من RETM.
      </div>
    </div>
  );
}

const th = { padding: "9px 12px", textAlign: "start", fontSize: 11, fontWeight: 800 };
const td = { padding: "9px 12px", textAlign: "start" };
